export const ERROR_MAKING_SLIDE_FAVORITE_MESSAGE =
  'An error occurred when making slide favorite!';

export const YELLOW_MARKED = '#f7cb4d';
